import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PageNotFound from './pages/PageNotFound.js';
import Stories from './pages/linkedPages/Stories.js'
import Story from './pages/linkedPages/Story.js'
import Typeface from './pages/linkedPages/Typeface.js'
import Type from './pages/linkedPages/Type.js'
import Brands from './pages/linkedPages/Brands.js'
import Authors from './pages/linkedPages/Authors.js'
import Calisthenics from './pages/linkedPages/Calisthenics.js'
import AIFree from './pages/linkedPages/AIFree.js'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <BrowserRouter>
       <Routes>
        <Route path="/" element={ <App/> } />
        <Route path="/stories" element={ <Stories/> } />
        <Route path="/type" element={ <Type/> } />
        <Route path="/brands" element={ <Brands/> } />
        <Route path="/authors" element={ <Authors/> } />
        <Route path="/creative-calisthenics" element={ <Calisthenics/> } />
        <Route path="/story/:storyShortName" action={({ params }) => {}} element={ <Story /> } />
        <Route path="/typeface/:typeFaceName" action={({ params }) => {}} element={ <Typeface /> } />
        <Route path="/ai-free" element={ <AIFree/> } />
        <Route path="*" element={ <PageNotFound/> } />
      </Routes>
      </BrowserRouter>,
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();